module.exports = __webpack_public_path__ + "static/logo-hitachi-solutions-c037bea0bcc776ad9330bee92a1d36e6.png";